import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";

const HomePage = lazy(() => import("./pages/HomePage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const ProductPage = lazy(() => import("./pages/ProductPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const DisclaimerPage = lazy(() => import("./pages/legal/DisclaimerPage"));
const PrivacyPage = lazy(() => import("./pages/legal/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/legal/TermsPage"));
const RefundPage = lazy(() => import("./pages/legal/RefundPage"));
const CancellationPage = lazy(() => import("./pages/legal/CancellationPage"));

const App = () => (
  <Routes>
    <Route path="/" element={<AppLayout />}>
      <Route index element={<HomePage />} />
      <Route path="ourServices" element={<ServicesPage />} />
      <Route path="about_us" element={<AboutPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="product" element={<ProductPage />} />
      <Route path="disclaimer" element={<DisclaimerPage />} />
      <Route path="privacy-policy" element={<PrivacyPage />} />
      <Route path="refund-policy" element={<RefundPage />} />
      <Route path="term-condition" element={<TermsPage />} />
      <Route path="cancellation-policy" element={<CancellationPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default App;
